import { render, staticRenderFns } from "./geren.vue?vue&type=template&id=086003fe&scoped=true"
import script from "./geren.vue?vue&type=script&lang=js"
export * from "./geren.vue?vue&type=script&lang=js"
import style0 from "./geren.vue?vue&type=style&index=0&id=086003fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086003fe",
  null
  
)

export default component.exports